<template>
    <!-- Delivery day field -->
    <div :class="inputClass">
        <label
            class="input__label"
            v-text="$t('DELIVERY_DAY_FIELD_FIRST_DELIVERY')"/>

        <multiselect
            v-model="selectedDate"
            :placeholder="$t('DELIVERY_DAY_FIELD_PLEASE_SELECT')"
            openDirection="below"
            label="label"
            track-by="value"
            :allow-empty="false"
            :show-labels="false"
            :options="availableDeliveryDays"/>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { isPostcodeFormatValid } from '@/helpers/PostcodeHelpers';
import PostcodeService from '@/services/logistics/PostcodeService';

export default {
    name: 'DeliveryDayField',
    props: {
        postcode: {
            type: String,
            default: null,
        },
        value: {
            default: null,
        },
    },
    data() {
        return {
            availableDeliveryDays: [],
            selectedDate: null,
        };
    },
    computed: {
        inputClass() {
            return this.value ? 'input input--success' : 'input ';
        },

        isValid() {
            return this.selectedDate !== null;
        },
    },
    methods: {
        /**
         * Get the delivery days for postcode.
         *
         * @param {String} postcode
         *
         * @returns {void}
         */
        fetchDeliveryDatesForPostcode(postcode) {
            this.availableDeliveryDays = [];
            this.selectedDate = null;

            PostcodeService.getDeliveryDatesForPostcode(postcode, process.env.VUE_APP_ALLOWED_NUMBER_OF_DELIVERY_DAYS)
                .then(response => {
                    this.availableDeliveryDays = response.data.items
                        .map(item => {
                            return {
                                label: item.human,
                                value: item.value,
                            };
                        });
                })
                .catch(error => console.error(error));
        },
    },
    watch: {
        selectedDate: function(selectedDate) {
            this.$emit('input', selectedDate);
        },
        postcode: {
            handler(newPostcode) {
                if (isPostcodeFormatValid(newPostcode)) {
                    this.fetchDeliveryDatesForPostcode(newPostcode);
                }
            },
            immediate: true,
        },
        value: {
            handler(selectedDate) {
                this.selectedDate = selectedDate;
            },
            immediate: true,
        },
    },
    components: {
        Multiselect,
    },
};
</script>
